import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import { SuiModal, ComponentModalConfig, ModalSize, DatepickerMode, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { takeUntil, delay, debounceTime, distinctUntilChanged, tap, map, switchMap, catchError } from 'rxjs/operators';
import { SharedValidators, AppFilter, ConfirmModal } from 'src/modules/shared';
import { environment } from 'src/environments/environment';
import { UnitService, OrganizationService } from '../../services';
interface IUnitUserModalContext {
	title: string;
	data?: any;
}
function check(data: Array<any>, users) {
	for (let i = 0; i < data.length; i++) {
		var node = data[i];
		data[i]['selected'] = users.indexOf(node['appUserId']) > -1 ? true : false;
		console.log(data[i]['selected']);
	}
	return data;
}

@Component({
	selector: 'app-unit-user-modal',
	templateUrl: './unit-user-modal.component.html',
	styleUrls: [ './unit-user-modal.component.scss' ]
})
export class UnitUserModalComponent implements OnInit, OnDestroy {
	search: FormControl = new FormControl('');
	searchable: boolean = true;
	private unsubscribe$: Subject<void> = new Subject<void>();
	formSubmitAttempt: boolean;
	success: any;
	error: any;
	pending: boolean;
	newUserForm: FormGroup;
	existingUserForm: FormGroup;
	roles: Array<any>;
	unitUsers: Array<any>;
	unitUsersIndex: Array<any>;
	noUnitUsers: Array<any>;
	users: Array<any>;
	unit;
	emailError;
	emailServerError;
	public emailLoading = false;
	collapseNew: boolean = true;
	collapseExisting: boolean = true;
	constructor(
		private http: HttpClient,
		@Inject(DOCUMENT) private document,
		private fb: FormBuilder,
		private userService: OrganizationService,
		private unitSvc: UnitService,
		private modalService: SuiModalService,
		public modal: SuiModal<IUnitUserModalContext, void, void>
	) {
		this.roles = modal.context.data.roles;
		this.users = modal.context.data.users;
		this.unit = modal.context.data.unit;
		// this.newUserForm = fb.group({
		// 	userRole: [ '', Validators.required ],
		// 	appUserEmail: [ '', [ Validators.required, SharedValidators.email ] ]
		// });
		// this.existingUserForm = fb.group({
		// 	userRole: [ '', Validators.required ],
		// 	appUserId: [ '', [ Validators.required ] ]
		// });
		this.getUsersInNoUnit();
		this.getUsers();
	}
	isFieldValid(field: string) {
		return (
			(!this.newUserForm.get(field).valid && this.newUserForm.get(field).touched) ||
			(this.newUserForm.get(field).untouched && this.formSubmitAttempt)
		);
	}

	displayFieldCss(field: string) {
		return {
			error: this.isFieldValid(field)
		};
	}

	isFieldValidE(field: string) {
		return (
			(!this.existingUserForm.get(field).valid && this.existingUserForm.get(field).touched) ||
			(this.existingUserForm.get(field).untouched && this.formSubmitAttempt)
		);
	}

	displayFieldCssE(field: string) {
		return {
			error: this.isFieldValidE(field)
		};
	}

	displayFormCss(field: string) {
		return {
			loading: field
		};
	}

	getUsersInNoUnit() {
		let filter = new AppFilter({ rows: 10000 });
		let searchFilter = {
			groupOp: 'OR',
			rules: [
				{
					field: 'appUserEmail',
					op: 'cn',
					data: ''
				},
				{
					field: 'username',
					op: 'cn',
					data: ''
				},
				{
					field: 'firstName',
					op: 'cn',
					data: ''
				},
				{
					field: 'lastName',
					op: 'cn',
					data: ''
				}
			]
		};
		filter.filters = JSON.stringify(searchFilter);
		this.pending = true;
		this.unitSvc
			.getNoUnitUsers({
				organizationId: this.unit.organizationId,
				organizationUnitId: this.unit.organizationUnitId,
				params: filter
			})
			.subscribe(
				(res: any) => {
					this.pending = false;
					this.noUnitUsers = res;
				},
				(error) => {
					this.pending = false;
					this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
				}
			);
	}

	getUsers() {
		let filter = new AppFilter({ rows: 10000 });
		let searchFilter = {
			groupOp: 'OR',
			rules: [
				{
					field: 'appUserEmail',
					op: 'cn',
					data: ''
				},
				{
					field: 'username',
					op: 'cn',
					data: ''
				},
				{
					field: 'firstName',
					op: 'cn',
					data: ''
				},
				{
					field: 'lastName',
					op: 'cn',
					data: ''
				}
			]
		};
		filter.filters = JSON.stringify(searchFilter);
		this.pending = true;
		this.unitSvc
			.getUnitUsers({
				organizationId: this.unit.organizationId,
				organizationUnitId: this.unit.organizationUnitId,
				params: filter
			})
			.subscribe(
				(res: any) => {
					this.pending = false;
					this.unitUsers = res
				},
				(error) => {
					this.pending = false;
					this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
				}
			);
	}

	submit() {
		let users = this.noUnitUsers.filter((user) => user.selected == true);
		// let realUser =  users.map((user) => user.appUserId)
		if (users && users.length > 0) {
			this.pending = true;
			this.unitSvc
				.addUnitUser({
					organizationId: this.unit.organizationId,
					organizationUnitId: this.unit.organizationUnitId,
					body: { ids: users.map((user) => user.appUserId) }
				})
				.subscribe(
					(res) => {
						this.pending = false;
						this.success = 'Unit users updated successfully';
						this.getUsersInNoUnit();
						this.getUsers();
					},
					(error) => {
						this.pending = false;
						this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
					}
				);
		}
	}

	onDelete(event) {
		this.modalService
			.open(new ConfirmModal('Remove User?', 'Are you sure you want to remove user?', ModalSize.Tiny))
			.onApprove(() => {
				this.delete(event);
			})
			.onDeny(() => {
				// event.selected = true;
			});
	}

	delete(user) {
		this.pending = true;
		this.unitSvc
			.deleteUnitUser({
				organizationId: this.unit.organizationId,
				organizationUnitId: this.unit.organizationUnitId,
				appUserId: user.appUserId
			})
			.subscribe(
				(res) => {
					this.pending = false;
					this.success = 'User removed from unit successfully';
					this.getUsers();
					this.getUsersInNoUnit();
				},
				(error) => {
					this.pending = false;
					this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
				}
			);
	}

	submitExisting() {
		if (this.existingUserForm.valid) {
			this.pending = true;
			this.unitSvc
				.addUnitUser({
					organizationId: this.unit.organizationId,
					organizationUnitId: this.unit.organizationUnitId,
					body: this.existingUserForm.value
				})
				.subscribe(
					(res) => {
						this.pending = false;
						this.existingUserForm.reset();
						this.collapseExisting = !this.collapseExisting;
						this.success = 'User invited to unit successfully';
					},
					(error) => {
						this.pending = false;
						this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
					}
				);
		}
	}
	save() {
		this.modal.approve(null);
	}
	nullify() {
		this.success = null;
		this.error = null;
	}
	ngOnInit() {
		// this.document.body.classList.remove('panel');
	}
	// s
	ngOnDestroy(): void {
		// this.document.body.classList.add('panel');
	}
}

export class UnitUserModal extends ComponentModalConfig<IUnitUserModalContext, void, void> {
	constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
		super(UnitUserModalComponent, { title, data });

		this.isClosable = false;
		this.transitionDuration = 200;
		this.transition = 'slide left';
		this.size = size;
		this.isFullScreen = false;
		this.isInverted = false;
	}
}
